import styled from 'react-emotion';
import React from 'react';

import CenterDiv from '../components/CenterDiv';
import EmailFormDetails from '../components/EmailFormDetails';

const ContactDiv = styled.div`
  z-index: 22;
  position: relative;
  width: 100%;
  max-width: 1100px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 2rem;
  padding-right: 2rem;
`;

const EmailForm = styled.form`
  text-align: center;
  svg {
    fill: white;
  }
`;
const Shortcut = styled.div`
  position: relative;
  z-index: 0;
  top: -8rem;
  height: 1px;
  @media (max-width: 350px) {
    top: -10rem;
  }
`;

const ThanksDiv = styled.div`
  display: none;
  text-align: center;
  position: absolute;
  top: -52rem;
  z-index: 12;
  width: 100%;
  height: 50rem;
  background-color: ${props => props.theme.set.light.trimOn};
  opacity: 0;
  border-radius: ${props => props.theme.borderRadius.round};
  box-shadow: 0px 6px 18px 0px rgba(0, 0, 0, 1);
  transition: all 0.2s cubic-bezier(0.165, 0.84, 0.44, 1);
`;

const ThanksSpan = styled.span`
  display: inline;
  position: relative;
  top: 20rem;
`;


const PostFrame = styled.iframe`
  display: none;
`;

let host = '';
if (typeof window !== 'undefined') {
  host = window.location.hostname;
}

if (host.match('localhost')) {
  host = `${host}:8000`;
}

let frameCount = 0;
let frameMax = 100;

const EmailContact = () => {
  const checkIframe = () => {
    if (frameCount <= frameMax) {
      if (!document.getElementById('postFrame').contentDocument) {
        window.location.href = `//${host}/thanks/#email`;
      }

      if (frameCount <= 10) { setTimeout(checkIframe, 50); }
      else { setTimeout(checkIframe, 350); }
      //alert(frameCount);

      frameCount++;
    }
  }

  const handleSubmit = e => {

    if (typeof document.getElementById('SpaceLabel').value !== 'undefined') {
      e.preventDefault();
      //alert(document.getElementById('SpaceLabel').value);
      // alert("spam");
    }
    else {
      // if (agent !== "safari") {
      //   document.getElementById("thanks").style.display = "inline";
      //   document.getElementById("thanks").style.opacity = 0.95;
      //   document.getElementById("EmailForm").style.opacity = 0;
      // }
    }

    frameCount = 0;
    frameMax = 100;

    checkIframe();
  };

  return (
    <ContactDiv>
      <PostFrame id="postFrame" name="postFrame" />
      <Shortcut name="email" />
      <EmailForm
        id="EmailForm"
        data-email="example@email.net"
        method="POST"
        action="https://&#102;&#97;&#98;&#102;&#111;&#114;&#109;&#46;&#105;&#111;&#47;&#102;&#47;&#65;&#86;&#51;&#78;&#84;&#117;&#85;"
        onSubmit={e => handleSubmit(e)}
        target="postFrame"
      >
        <input type="hidden" value={host} />
        <EmailFormDetails />
      </EmailForm>
      <CenterDiv>
        <ThanksDiv id="thanks">
          <ThanksSpan>
            <h1>Message Sent</h1>
            <h2>Thank You!</h2>
          </ThanksSpan>
        </ThanksDiv>
      </CenterDiv>
    </ContactDiv>
  );
};
export default EmailContact;



// WEBPACK FOOTER //
// ./src/components/EmailContact.jsx